import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAcknowledgement = () => {
	const { shouldUserSignTnc, shouldUserProvideDeclaration } = useAuth();
	const location = useLocation();

	var shouldShowAckPage = shouldUserProvideDeclaration || shouldUserSignTnc;
	if (shouldShowAckPage && location.pathname !== "/user-acknowledgements") {
		// T&C pending and user is trying to visit a protected page
		return <Navigate to="/user-acknowledgements" state={{ from: location }} replace />;
	}

	if (!shouldShowAckPage && location.pathname === "/user-acknowledgements") {
		// T&C not pending and user is trying to visit user ack page
		return <Navigate to="/" />;
	}

	// All checks passed
	return <Outlet />;
};

export default RequireAcknowledgement;
